module.exports = __webpack_public_path__ + "static/img/f-i-one.b4f2740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-four/f-i-one.png
// module id = S22j
// module chunks = 0